import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'
import Captcha from './Captcha'
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha'

function resetByEmail() {
    const [pesan, setPesan] = useState(false)
    const [email, setEmail] = useState('') // Diubah dari no_hp ke email
    const [captcha, setCaptcha] = useState("")
    const [recaptcha, setReCaptcha] = useState("")
    const [msg, setMsg] = useState('')
    const navigate = useNavigate()
    const alert = {
        position: "relative",
        top: "7px",
        backgroundColor: "#e5df7c",
        color: "#333",
    }

    useEffect(() => {
        loadCaptchaEnginge(6)
    }, [])

    const Auth = async (e) => {
        e.preventDefault()
        if (validateCaptcha(captcha) === false) {
            setReCaptcha("Captcha tidak sesuai!")
            setTimeout(() => {
                setReCaptcha("")
            }, 2000)
            setCaptcha("")
        } else {
            try {
                // Mengirim payload dengan field email ke endpoint reset
                const response = await axios.post('/api/pelaku-usaha/reset-by-email', {
                    email
                })
                getPesan()
                setMsg(response.data.msg)
                setTimeout(() => {
                    getPesan()
                    setMsg('')
                }, 2000)
                setTimeout(() => {
                    navigate('/login')
                }, 4000)
            } catch (err) {
                getPesan()
                loadCaptchaEnginge(6)
                setCaptcha("")
                setReCaptcha("")
                setMsg(err.response && err.response.data && err.response.data.msg ? err.response.data.msg : 'Maaf, proses pengiriman data gagal silahkan coba lagi!')
                setTimeout(() => {
                    getPesan()
                    setMsg('')
                }, 2000)
            }
        }
    }

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    return (
        <>
            <div className="bg-full-page bg-primary back-fixed">
                <div className="mw-500 absolute-center">
                    <div className="card color-dark animated zoomInDown animation-delay-5 border-radius-20">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <h3 className="color-success">Reset Password</h3>
                                </div>
                                <div className="col-md-6 col-6">
                                    <img width="100%" src="assets/img/logo-head.png" alt="" />
                                </div>
                            </div>
                            <form onSubmit={Auth}>
                                <fieldset>
                                    <div className="form-group">
                                        <label className="control-label" htmlFor="email-login">Alamat Email</label>
                                        <div className="input-group">
                                            <span className="input-group-addon"><i className="zmdi zmdi-email"></i></span>
                                            <input type="email" id="email-login" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Masukkan email terdaftar *" required />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="text-center">
                                            <Captcha />
                                        </div>
                                        <label className="control-label" htmlFor="capthcha">Captcha</label>
                                        <p style={alert} className="text-center">
                                            {recaptcha}
                                        </p>
                                        <div className="input-group">
                                            <span className="input-group-addon"><i className="fa fa-lock"></i></span>
                                            <input className="form-control" type="text" value={captcha} placeholder="Masukan Captcha *" onChange={(e) => setCaptcha(e.target.value)} required />
                                        </div>
                                    </div>
                                    <div className="row ">
                                        <div className="col-md-6 col-6">
                                            <button className="btn btn-raised btn-warning btn-block p-1 br-2"><i className="zmdi zmdi-key no-ml mr-1"></i>RESET PASSWORD</button>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <Link to={'/login'} className="btn btn-raised btn-success btn-block p-1 br-2"><i className="zmdi zmdi-lock mr-1"></i> MASUK</Link>
                                        </div>
                                        <div className="col-md-12 text-center mt-2">
                                            Belum punya akun? <Link className="color-success" to={'/register'}>Daftar</Link> atau kembali <Link className="color-success" to={'/'}>Beranda</Link>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className={pesan ? "modal-open" : ""}>
                <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog center">
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                    PESAN
                                </h4>
                            </div>
                            <div className="modal-body text-center">
                                <h4 className="font-bold">{msg.toUpperCase()}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {pesan ? <div className="modal-backdrop fade in"></div> : ""}
        </>
    )
}

export default resetByEmail